interface MarketLogoProps {
	size?: 'sm' | 'md' | 'lg';
	id: number;
}

export default function MarketLogo(props: MarketLogoProps) {
	const size = props.size ? props.size : 'md';

	return (
		<div className="market-logo-img">
			<img src={`/assets/common/logos/${props.id}_${size}.png`} />
		</div>
	);
}
